import { render } from "./Opportunita-home.vue?vue&type=template&id=375157de"
import script from "./Opportunita-home.vue?vue&type=script&lang=js"
export * from "./Opportunita-home.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__